import React from "react";
import { Container } from "../../components/layouts/container";
import { Layout } from "../../components/layouts/layout";
import { TableProduct } from "../../components/ui/TableProduct";
import { ProgressBar } from "../../components/ui/ProgressBar";
import { Vedettes } from "../../components/ui/Vedettes";

export const DashboardPage: React.FC = () => {

  return (
    <Layout>
      <Container className="py-6">
        <div className="relative mx-auto grid h-full w-full grid-cols-1 items-start justify-center">
          <Vedettes />
          <div className="py-8">
            <ProgressBar />
          </div>
          <main className="flex-1 py-4 sm:py-6 md:py-8">
            <div className="grid gap-8">
              <TableProduct />
            </div>
          </main>
        </div>
      </Container>
    </Layout>
  );
};